import brochureMainRight from './widgets/brochureMainRight.js';
import brochureMainLeft from './widgets/brochureMainLeft.js';
import brochureCardWidgets from './widgets/brochureCardWidgets.js';
import brochureTextButtons from './widgets/brochureTextButtons.js';

function brochureStructure() {
  if ($('body').hasClass('bigELanding')) {
    brochureMainLeft();
    brochureMainRight();
    brochureCardWidgets();
    brochureTextButtons();
  }
}

export { brochureStructure };
